module.exports = __webpack_public_path__ + "img/invite.73379d20.png";